import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user || !user.token || !user.role) {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/menu" replace />;
  }

  if (!adminOnly && location.pathname === '/menu' && user.role === 'admin') {
    return <Navigate to="/admin/organs" replace />;
  }

  if (user.role === 'user_pending' && location.pathname !== '/consent') {
    return <Navigate to="/consent" replace />;
  }

  if (user.role !== 'user_pending' && location.pathname === '/consent') {
    return <Navigate to="/menu" replace />;
  }

  return children;
}

export default ProtectedRoute;
